// extracted by mini-css-extract-plugin
module.exports = {"vendor_image_container":"VendorImage_vendor_image_container__1lmUX","vendor_image":"VendorImage_vendor_image__38yq7"};